export default __webpack_public_path__ + "1.19.2/static/media/LibreDataShare_Hebrew.9abfb84b.svg";